import axios from 'axios'
import { withHeadersInstance } from './api-instance'
import qs from 'qs'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetStaff = async function(parameters) {
    try {
        const { publicId, locationPublicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/staff/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutStaff = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/staff/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteStaff = async function(parameters) {
    try {
        const { publicId } = parameters

        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/staff/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/staffs${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostStaff = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/staff`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeStaffStatus = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined) {
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        }

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/staff/${publicId}/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
